import React from 'react'
import { Breadcrumbs, Typography } from '@material-ui/core'
import { Link } from 'gatsby-theme-material-ui'

const BreadCrumb = ({ title, breadCrumb }) => (
  <Breadcrumbs aria-label="breadcrumb">
    {breadCrumb.map(page => (
      <Link
        style={{ color: 'blue' }}
        className={`link`}
        key={page.slug}
        to={page.slug === '' ? `/` : `${page.slug}`}
      >
        {page.title}
      </Link>
    ))}
    <Typography color="textPrimary">{title}</Typography>
  </Breadcrumbs>
)

export default BreadCrumb
